import TemplateView from "./TemplateView"
import SpinnerController from "./SpinnerController"
import Spinner from "./spin.min"

export default class LoadingMoire extends TemplateView {
    constructor({
        additionalClass = '',
        additionalSpinnerSettings,
        showAnimated = true,
        hideAnimated = true,
        delay,
        innerContent = null,
    } = {}) {
        super()

        this.params = {
            additionalClass,
            additionalSpinnerSettings,
            showAnimated,
            hideAnimated,
            delay,
            innerContent,
        }
    }

    templateHtml() {
        return "<div class='loadingMoire <%=additionalClass%>'>" +
               "    <div class='spinnerPlaceholder'></div>" +
               "</div>"
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    afterRender() {
        this.$el.hide()
        this.$spinnerPlaceholder = this.find('.spinnerPlaceholder')
        this.spinnerController = new SpinnerController(true)
        let spinnerSettings = SpinnerController.getDefaultSettings()
        spinnerSettings = {
            ...spinnerSettings,
            ...this.params.additionalSpinnerSettings
        }
        this.spinnerController.setSpinner(new Spinner(spinnerSettings))

        if (this.params.innerContent) {
            this.params.innerContent.init(this.$el)
        }
    }

    show() {
        clearTimeout(this._showOpaqueTimeout)
        this._showOpaqueCalled = false

        if (this.params.delay) {
            this._showTransparent()
            this._showOpaqueTimeout = setTimeout(() => this._showOpaque(), this.params.delay)
        } else {
            this._showOpaque()
        }
    }

    hide() {
        clearTimeout(this._showOpaqueTimeout)

        if (this.params.hideAnimated && this._showOpaqueCalled)
            this.$el.atAnimation().fadeOut()
        else
            this.$el.hide()

        this.spinnerController.stop()
    }

    toggle(isLoading) {
        if (isLoading) {
            this.show()
        } else {
            this.hide()
        }
    }

    _showTransparent() {
        this.$el.addClass('transparent')
        this.$el.show()
    }

    _showOpaque() {
        this.$el.removeClass('transparent')
        this._showOpaqueCalled = true
        if (this.params.showAnimated)
            this.$el.atAnimation().fadeIn()
        else
            this.$el.show()
        this.spinnerController.spinInElement(this.$spinnerPlaceholder)
    }
}


// WEBPACK FOOTER //
// ./web/js/LoadingMoire.js